import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { sharedReportsValidateCode } from 'apiServices/reducer/apiService';
import { CTGrid, CTSearchView } from '../../../components';
import { getMRSitesReports } from 'apiServices/reducer/apiService';
import { ReportDisplaySection } from '../../../components/ReportDisplaySection';
import ReportPreview from "../../../components/previewControls";
import { buildPdfPreviewSrc } from '../../../utils/utils';

const ViewSharedReports = () => {
    const gridRef = useRef(null);
    const previewContainerRef = useRef(null);
    const iframeRef = useRef(null);

    // State variables
    const [activeTab, setActiveTab] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedReportName, setSelectedReportName] = useState("");
    const [selectedReportID, setSelectedReportID] = useState("");
    const [pdfUrl, setPdfUrl] = useState(null);

    // Redux state
    const dispatch = useDispatch();
    const token = useSelector((state) => state.apiService.token);
    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);
    const userId = menuData?.user_id;
    const isAccess = menuData.role === 'User';

    // Column definitions for the grid
    const columnDefs = [
        {
            field: 'name',
            headerName: 'Report Name',
            sortable: true,
            filter: true,
            flex: 2,
            tooltipField: 'name',
            headerTooltip: 'Report Name',
        },
        {
            field: 'date',
            headerName: 'Report Date',
            sortable: true,
            filter: true,
            width: 130,
            tooltipField: 'date',
            headerTooltip: 'Report Date',
            valueFormatter: (params) => {
                if (params.value) {
                    return new Date(params.value).toLocaleDateString();
                }
                return '';
            }
        },
        {
            field: 'source',
            headerName: 'Source',
            sortable: true,
            filter: true,
            width: 180,
            tooltipField: 'source',
            headerTooltip: 'Source',
        },
    ];

    // Event handlers
    const onFullScreenToggle = () => {
        setIsFullscreen(!isFullscreen);
    };

    const onDeleteReport = () => {
        // Implement delete report functionality
        console.log("Delete report clicked");
    };

    const onArchiveReport = () => {
        // Implement archive report functionality
        console.log("Archive report clicked");
    };

    const onDownloadReport = () => {
        // Implement download report functionality
        console.log("Download report clicked");
    };

    const onShareReport = () => {
        // Implement share report functionality
        console.log("Share report clicked");
    };

    const onEditReport = () => {
        // Implement edit report functionality
        console.log("Edit report clicked");
    };

    // Update onRowClicked to handle PDF preview
    const onRowClicked = (event) => {
        const report = event.data;
        setSelectedReport(report);
        setSelectedReportName(report.name);
        setSelectedReportID(report.id || "");

        // Assuming the report data contains a URL or path to the PDF
        // You might need to adjust this based on your actual data structure
        if (report.pdf_url || report.report_url) {
            const pdfUrl = report.pdf_url || report.report_url;
            setPdfUrl(pdfUrl);
        } else {
            console.warn("No PDF URL found for the selected report");
            setPdfUrl(null);
        }
    };

    // Fetch reports data
    useEffect(() => {

        const params = {
            token: isAccess ? menuData.Token : token,
            UserID: userId,
            ReportGroupName: "",
            ProviderName: "",
            HospitalName: "",
            SearchKey: searchQuery,
            ReportDateStart: "",
            ReportDateEnd: "",
        };

        console.log("Fetching reports with params:", params);
        dispatch(getMRSitesReports(params))
            .then((resp) => {
                console.log("reportsData", resp.payload);
                const fetchedData = resp.payload.Table;// Use fetched data directly
                console.log("fetchedData", fetchedData);
                const formattedData = fetchedData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    source: report.source,
                }));
                setRowData(formattedData);
                // setRowDatanew(formattedData);

            })
            .catch(error => {
                console.error("Error fetching reports:", error);
                setRowData([]);
            })



    }, [dispatch, menuData.Token, userId, searchQuery, isAccess, menuData]);

    const clearReportPreview = () => {
        setPdfUrl((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });
        setSelectedReport(null);
        setSelectedReportName("");
        setSelectedReportID("");
    };

    const onSearchChange = (e) => {
        clearReportPreview();
        setSearchQuery(e.target.value);
    };

    const onSearchClear = () => {
        clearReportPreview();
        setSearchQuery("");
    };

    const onAdvanceSearchClick = () => {
        console.log("Advance search clicked");
    };

    return (
        <div className="container-fluid">
            <div className="row mb-3">
                <div className="col-12">
                    <CTSearchView
                        placeholder="Search reports"
                        onChange={onSearchChange}
                        onChangeclear={onSearchClear}
                        advanceSearchClick={onAdvanceSearchClick}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="col-12">
                        <div className="ag-theme-balham p-2 border rounded shadow-sm" style={{ height: '600px' }}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                onRowClicked={onRowClicked}
                                enableBrowserTooltips={true}
                                tooltipShowDelay={0}
                                pagination={true}
                                paginationPageSize={10}
                                defaultColDef={{
                                    resizable: true,
                                    sortable: true,
                                    filter: true
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div ref={previewContainerRef} className="preview-container border rounded shadow-sm"
                        style={{
                            height: '600px',
                            position: isFullscreen ? 'fixed' : 'relative',
                            top: isFullscreen ? 0 : 'auto',
                            left: isFullscreen ? 0 : 'auto',
                            width: isFullscreen ? '100vw' : '100%',
                            height: isFullscreen ? '100vh' : '600px',
                            zIndex: isFullscreen ? 9999 : 'auto',
                            backgroundColor: 'white',
                            overflow: 'hidden'
                        }}>
                        {pdfUrl ? (
                            <div className="h-100 w-100">
                                <ReportPreview
                                    selectedReport={selectedReport}
                                    selectedReportName={selectedReportName}
                                    selectedReportID={selectedReportID}
                                    onFullScreenToggle={onFullScreenToggle}
                                    isFullscreen={isFullscreen}
                                />
                                <iframe
                                    key={pdfUrl}
                                    ref={iframeRef}
                                    src={buildPdfPreviewSrc(pdfUrl, { toolbar: 0 })}
                                    className="w-100 h-100"
                                    style={{ border: 'none' }}
                                    title="PDF Preview"
                                />
                            </div>
                        ) : (
                            <div className="h-100 d-flex align-items-center justify-content-center">
                                <p className="text-muted">Select a report to preview</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewSharedReports; 